<script setup>
import { reactive } from 'vue'
import {
  KkModal,
  KkCheckbox
} from '../../../../components/base'

const emit = defineEmits(['submit', 'close'])
const state = reactive({
  storeUuids: []
})
const props = defineProps({
  condition: { type: Object, required: true },
})
const handleSubmit = () => {
  emit('submit', state.storeUuids)
}

const checkStores = (uuid) => {
  if(state.storeUuids.includes(uuid)) {
    state.storeUuids = state.storeUuids.filter(v => v !== uuid)
  } else {
    state.storeUuids.push(uuid)
  }
}

const checkAllStores = () => {
  if(state.storeUuids.length === props.condition.stores.length) {
    state.storeUuids = []
  } else {
    state.storeUuids = props.condition.stores.map(v => v.uuid)
  }
}
</script>
<template>
  <KkModal :is-visible="state.storeModal" @change="emit('close')">
    <div class="content__header">
      {{ $t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.storeModalTitle', { title: props.condition.name }) }}
    </div>
    <div class="content__body">
      <KkCheckbox
        id="allCheckModal"
        class="allCheck"
        :model-value="state.storeUuids.length === condition.stores.length"
        :label="$t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.allCheck')"
        @change="checkAllStores"
      />
      <div v-for="(store, index) in props.condition.stores" :key="index" class="item">
        <KkCheckbox
          :id="`modal-${store.uuid}`"
          :model-value="state.storeUuids.includes(store.uuid)"
          :label="store.name"
          @change="checkStores(store.uuid)"
        />
      </div>
    </div>
    <div class="content__footer">
      <div class="c-button">
        <i18n-t keypath="pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.storesCount" class="store-count-wap">
          <span class="store-count">{{ state.storeUuids.length }}</span>
        </i18n-t>
        <button
          class="c-button__item c-button__item--outline-cancel"
          @click="emit('close')"
        >
          {{ $t('labels.cancel') }}
        </button>
        <button
          class="c-button__item c-button__item--primary"
          :class="{'c-button__item--disabled': state.storeUuids.length === 0 }" :disabled="state.storeUuids.length === 0"
          @click="handleSubmit"
        >
          {{ $t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.removeStore') }}
        </button>
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }

  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }

  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;
    .item {
      padding: 18px;
      border: 1px solid #E4E7EB;
      border-radius: 4px;
      margin: 10px 0;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
.store-count-wap {
  margin-right: 10px;
}
.store-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
.allCheck {
  font-weight: bold;
}
</style>
